/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Write_Note_PlaceholderInputs */

const en_mobile_write_note_placeholder = /** @type {(inputs: Mobile_Write_Note_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Write your note…`)
};

const es_mobile_write_note_placeholder = /** @type {(inputs: Mobile_Write_Note_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escribe tu nota…`)
};

/**
* | output |
* | --- |
* | "Write your note…" |
*
* @param {Mobile_Write_Note_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_write_note_placeholder = /** @type {((inputs?: Mobile_Write_Note_PlaceholderInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Write_Note_PlaceholderInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_write_note_placeholder(inputs)
	return en_mobile_write_note_placeholder(inputs)
});